export const registrationName = (registration: GQL.IRegistration): string => {
  return `${registration.lastName} ${registration.firstName}`;
};
